var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m27 6.4-.6 2 1 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m27 6.4.6 2-1 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M28.9 7.7h-2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M28.9 7.7 27.2 9l-.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m28.2 10-.7-2-1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m28.2 10-1.7-1.3.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M25.1 7.7h2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M25.1 7.7 26.8 9l.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m25.8 10 .7-2 1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m25.8 10 1.7-1.3-.7-.8zM27 30l-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m27 30 .6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M28.9 31.4h-2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m28.9 31.4-1.7 1.2-.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m28.2 33.6-.7-1.9-1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m28.2 33.6-1.7-1.2.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M25.1 31.4h2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m25.1 31.4 1.7 1.2.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m25.8 33.6.7-1.9 1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m25.8 33.6 1.7-1.2-.7-.7zM15.1 18.2l-.5 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15.1 18.2.6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M17 19.6h-2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m17 19.6-1.7 1.2-.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m16.3 21.8-.7-2-.9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m16.3 21.8-1.6-1.3.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M13.3 19.6h2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m13.3 19.6 1.7 1.2.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m14 21.8.7-2 .9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m14 21.8 1.6-1.3-.7-.7zm6-10.2 1.7-1.2-.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m20 11.6.7-2 1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m19.3 9.4 1.7 1.2.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M19.3 9.4h2.1l-.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m21.2 8-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m21.2 8 .6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m22.4 11.6-1.7-1.2.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m22.4 11.6-.7-2-1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m23.1 9.4-1.7 1.2-.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M23.1 9.4h-2v1zM18 16l-.7-2-1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m18 16-1.7-1.2.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15.7 16 1.6-1.2-.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15.7 16 .6-2 1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15 13.8 1.6 1.2.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M15 13.8h2l-.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M18.7 13.8 17 15l-.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M18.7 13.8h-2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m16.8 12.4.6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m16.8 12.4-.6 2 1 .2zm1.9 13.3h-2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M18.7 25.7 17 26.9l-.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m18 27.9-.7-2-1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m18 27.9-1.7-1.3.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15.7 27.9 1.6-1.3-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15.7 27.9.6-2 1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m16.8 24.3.6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m16.8 24.3-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M15 25.7h2l-.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15 25.7 1.6 1.2.5-1zm8 4h-2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m23 29.7-1.7 1.1-.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m22.3 31.9-.7-2-1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m22.3 31.9-1.7-1.3.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m20 31.9 1.6-1.3-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m20 31.9.6-2 1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m21.1 28.3.6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m21.1 28.3-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M19.2 29.7h2.1l-.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m19.2 29.7 1.7 1.1.5-.8zm19.7-11.5.5 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m38.9 18.2-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M37 19.6h2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m37 19.6 1.7 1.2.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m37.7 21.8.7-2 .9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m37.7 21.8 1.6-1.3-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M40.7 19.6h-2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M40.7 19.6 39 20.8l-.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m40 21.8-.7-2-.9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m40 21.8-1.6-1.3.7-.7zm-6-10.2-1.7-1.2.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m34 11.6-.7-2-1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M34.7 9.4 33 10.6l-.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M34.7 9.4h-2.1l.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m32.8 8 .6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m32.8 8-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m31.6 11.6 1.7-1.2-.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m31.6 11.6.7-2 1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m30.9 9.4 1.7 1.2.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M30.9 9.4h2v1zM36 16l.7-2 1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m36 16 1.7-1.2-.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m38.3 16-1.6-1.2.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m38.3 16-.6-2-1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M39 13.8 37.5 15l-.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M39 13.8h-2l.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M35.3 13.8 37 15l.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M35.3 13.8h2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m37.2 12.4-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m37.2 12.4.6 2-1 .2zm-1.9 13.3h2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m35.3 25.7 1.7 1.2.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m36 27.9.7-2 1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m36 27.9 1.7-1.3-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m38.3 27.9-1.6-1.3.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m38.3 27.9-.6-2-1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m37.2 24.3-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m37.2 24.3.6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M39 25.7h-2l.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m39 25.7-1.6 1.2-.5-1zm-8 4h2v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m31 29.7 1.7 1.1.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m31.7 31.9.7-2 1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m31.7 31.9 1.7-1.3-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m34 31.9-1.6-1.3.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m34 31.9-.6-2-1 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m32.9 28.3-.6 2 1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m32.9 28.3.6 2-1 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M34.8 29.7h-2.1l.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M34.8 29.7 33 30.8l-.5-.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.2eeaa788471393a14ea634a32eedab37.svg";
export { ForwardRef as ReactComponent };